import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogRedisCaching() {
  return <BlogDetailPage slug="redis-caching-in-laravel-applications" />;
}